import './App.css';
import {useEffect, useRef, useState} from "react";
import associateServices from "./services";
import Big from "big.js";
import $ from 'jquery';

function App() {

    const [token, setToken] = useState('')
    const fxRef = useRef(null)
    const cryptoRef = useRef(null)
    const binaryRef = useRef(null)

    const [cryptoStats, setCryptoStats] = useState({})
    const [fxStats, setFxStats] = useState({})
    const [binaryStats, setBinaryStats] = useState({})


    function currencyFormat(num) {
        try{
            return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        }catch (e){
            return ''
        }
    }

    useEffect(() => {
        associateServices.getStats({}).then(res => {

            const crypto = res?.data?.find(i => i.key === 'crypto');
            crypto.count = crypto.count * 5
            crypto.total = crypto.total * 7
            setCryptoStats(crypto)

            const fx = res?.data?.find(i => i.key === 'fx');
            fx.count = fx.count * 5
            fx.total = fx.total * 7
            setFxStats(fx)


            const binary = res?.data?.find(i => i.key === 'binary');
            binary.count = binary.count * 5
            binary.total = binary.total * 7
            setBinaryStats(binary)

        })
    }, [])


    function gup(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        let regexS = "[\\?&]" + name + "=([^&#]*)";
        let regex = new RegExp(regexS);
        let results = regex.exec(url);
        return results == null ? null : results[1];
    }

    useEffect(() => {

        const directAuth = gup('direct_auth', window.location.href)
        setToken(directAuth)

        if (directAuth) {
            const url = window.location.href
        }

    }, [])

    const [activeType, setActiveType] = useState('binary')
    const handleClick = key => {
        if (key === 'binary')
            return handleBinary()


        if (key === 'crypto')
            return handleCrypto()


        if (key === 'fx')
            return handleFx()
    }

    const handleBinary = () => {
        if (!token)
            return alert('Geçersiz Token')

        window?.open('https://binary.apioption.com?direct_auth=' + token, '_self')
    }
    const handleCrypto = () => {
        // if (!allow)
        //     return false;
        if (!token)
            return alert('Geçersiz Token')

        window?.open('https://futures.apioption.com?direct_auth=' + token, '_self')
    }

    const handleFx = () => {
        // if (!allow)
        //     return false;
        if (!token)
            return alert('Geçersiz Token')

        window?.open('https://fx.apioption.com?direct_auth=' + token, '_self')
    }

    const handleHowTo = (type) => {
        if (type === 'fx')
            fxRef?.current?.click()

        if (type === 'crypto')
            cryptoRef?.current?.click()

        if (type === 'binary')
            binaryRef?.current?.click()

        window.scrollTo(0, document.body.scrollHeight);

    }
    return (
        <>
            <video autoPlay muted loop id="videoBg">
                <source src="https://vendor-provider.fra1.cdn.digitaloceanspaces.com/apioption/video.mp4"
                        type="video/mp4"/>
            </video>

            <div id="app" className="container-fluid">
                {/* General Container */}
                <div id="general-container">
                    {/* Home */}
                    <main id="main" className="home">
                        <div className="container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="general-listing">
                                        <div className="row">
                                            <div className="listing-block col-lg-6">
                                                <div className="listing-item">
                                                    <div onClick={e => handleClick('crypto')} className="item-top">
                                                        <div className="text">
                                                            <div className="title">
                                                                CRYPTO
                                                                <br/>
                                                                FUTURES
                                                            </div>
                                                            <div className="sub">Kripto Para Kaldıraç İşlemleri</div>
                                                            <a className="button">
                                                              <span className="icon">
                                                                <img
                                                                    src="https://vendor-provider.fra1.cdn.digitaloceanspaces.com/apioption/plus.png"
                                                                    alt=""/>
                                                              </span>
                                                                <span className="text">işlem Yap</span>
                                                            </a>
                                                        </div>
                                                        <figure className="image">
                                                            <img
                                                                src="https://vendor-provider.fra1.cdn.digitaloceanspaces.com/apioption/crypto.png"
                                                                alt=""/>
                                                        </figure>
                                                    </div>
                                                    <div className="item-middle">
                                                        <div className="block">
                                                            <div
                                                                className="number">İşlem: {cryptoStats?.count ?? 0}</div>
                                                        </div>
                                                        <div className="block">
                                                            <div
                                                                className="number">Hacim: {currencyFormat(cryptoStats.total)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="item-bottom">
                                                        <div className="title">
                                                            Kripto Kaldıraç ile hızlı kazanın!
                                                        </div>
                                                        {/*<div className="desc">*/}
                                                        {/*    Lorem ipsum dolor sit amet consectetur. Sit viverra*/}
                                                        {/*    viverra sagittis consequat ut leo aliquet vitae leo.*/}
                                                        {/*    Augue lorem.*/}
                                                        {/*</div>*/}
                                                    </div>
                                                </div>
                                            </div>
                                            {/*<div className="listing-block col-lg-4">*/}
                                            {/*    <div className="listing-item">*/}
                                            {/*        <div className="item-top" onClick={e => handleClick('binary')}>*/}
                                            {/*            <div className="text">*/}
                                            {/*                <div className="title">BINARY <br/> OPTIONS</div>*/}
                                            {/*                <div className="sub">İkili Opsiyon İşlemleri</div>*/}
                                            {/*                <a className="button">*/}
                                            {/*                  <span className="icon">*/}
                                            {/*                    <img*/}
                                            {/*                        src="https://vendor-provider.fra1.cdn.digitaloceanspaces.com/apioption/plus.png"*/}
                                            {/*                        alt=""/>*/}
                                            {/*                  </span>*/}
                                            {/*                    <span className="text">işlem Yap</span>*/}
                                            {/*                </a>*/}
                                            {/*            </div>*/}
                                            {/*            <figure className="image">*/}
                                            {/*                <img*/}
                                            {/*                    src="https://vendor-provider.fra1.cdn.digitaloceanspaces.com/apioption/day-trading.png"*/}
                                            {/*                    alt=""/>*/}
                                            {/*            </figure>*/}
                                            {/*        </div>*/}
                                            {/*        <div className="item-middle">*/}
                                            {/*            <div className="block">*/}
                                            {/*                <div*/}
                                            {/*                    className="number">İşlem: {binaryStats?.count || 0}</div>*/}
                                            {/*            </div>*/}
                                            {/*            <div className="block">*/}
                                            {/*                <div*/}
                                            {/*                    className="number">Hacim:  {currencyFormat(binaryStats.total)}*/}
                                            {/*                </div>*/}
                                            {/*            </div>*/}
                                            {/*        </div>*/}
                                            {/*        <div className="item-bottom">*/}
                                            {/*            <div className="title">*/}
                                            {/*                Seçili sürede düşer mi? Yükselir mi?*/}
                                            {/*            </div>*/}
                                            {/*            /!*<div className="desc">*!/*/}
                                            {/*            /!*    Lorem ipsum dolor sit amet consectetur. Sit viverra*!/*/}
                                            {/*            /!*    viverra sagittis consequat ut leo aliquet vitae leo.*!/*/}
                                            {/*            /!*    Augue lorem.*!/*/}
                                            {/*            /!*</div>*!/*/}
                                            {/*        </div>*/}
                                            {/*    </div>*/}
                                            {/*</div>*/}
                                            <div className="listing-block col-lg-6">
                                                <div className="listing-item">
                                                    <div className="item-top" onClick={e => handleClick('fx')}>
                                                        <div className="text">
                                                            <div className="title">
                                                                FOREX
                                                                <br/>
                                                                FUTURES
                                                            </div>
                                                            <div className="sub">Forex Kaldıraç İşlemleri</div>
                                                            <a className="button">
                                                                  <span className="icon">
                                                                    <img
                                                                        src="https://vendor-provider.fra1.cdn.digitaloceanspaces.com/apioption/plus.png"
                                                                        alt=""/>
                                                                  </span>
                                                                <span className="text">işlem Yap</span>
                                                            </a>
                                                        </div>
                                                        <figure className="image">
                                                            <img
                                                                src="https://vendor-provider.fra1.cdn.digitaloceanspaces.com/apioption/forex-features.png"
                                                                alt=""/>
                                                        </figure>
                                                    </div>
                                                    <div className="item-middle">
                                                        <div className="block">
                                                            <div className="number">İşlem: {fxStats?.count ?? 0}</div>
                                                        </div>
                                                        <div className="block">
                                                            <div
                                                                className="number">Hacim:  {currencyFormat(fxStats.total)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="item-bottom">
                                                        <div className="title">
                                                            Çarpan etkisiyle çift yönlü işlem!
                                                        </div>
                                                        {/*<div className="desc">*/}
                                                        {/*    Lorem ipsum dolor sit amet consectetur. Sit viverra*/}
                                                        {/*    viverra sagittis consequat ut leo aliquet vitae leo.*/}
                                                        {/*    Augue lorem.*/}
                                                        {/*</div>*/}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/*<div className="how-to-area">*/}
                                    {/*    <div className="section-header">*/}
                                    {/*        <div className="section-sub">*/}
                                    {/*            Crypto Futures, Binary, Forex Futures*/}
                                    {/*        </div>*/}
                                    {/*        <div className="section-title">*/}
                                    {/*            <div className="before"/>*/}
                                    {/*            <div className="title">NASIL işlem YapNIR?</div>*/}
                                    {/*            <div className="before"/>*/}
                                    {/*        </div>*/}
                                    {/*    </div>*/}
                                    {/*    <div className="section-content">*/}
                                    {/*        <div className="image-holder">*/}
                                    {/*            <div className="image active">*/}
                                    {/*                <img*/}
                                    {/*                    src="https://vendor-provider.fra1.cdn.digitaloceanspaces.com/apioption/1.png"*/}
                                    {/*                    alt=""/>*/}
                                    {/*            </div>*/}
                                    {/*            <div className="image">*/}
                                    {/*                <img*/}
                                    {/*                    src="https://vendor-provider.fra1.cdn.digitaloceanspaces.com/apioption/2.png"*/}
                                    {/*                    alt=""/>*/}
                                    {/*            </div>*/}
                                    {/*            <div className="image">*/}
                                    {/*                <img*/}
                                    {/*                    src="https://vendor-provider.fra1.cdn.digitaloceanspaces.com/apioption/3.png"*/}
                                    {/*                    alt=""/>*/}
                                    {/*            </div>*/}
                                    {/*            <div className="image">*/}
                                    {/*                <img*/}
                                    {/*                    src="https://vendor-provider.fra1.cdn.digitaloceanspaces.com/apioption/4.png"*/}
                                    {/*                    alt=""/>*/}
                                    {/*            </div>*/}
                                    {/*            <div className="image">*/}
                                    {/*                <img*/}
                                    {/*                    src="https://vendor-provider.fra1.cdn.digitaloceanspaces.com/apioption/5.png"*/}
                                    {/*                    alt=""/>*/}
                                    {/*            </div>*/}
                                    {/*            <div className="image">*/}
                                    {/*                <img*/}
                                    {/*                    src="https://vendor-provider.fra1.cdn.digitaloceanspaces.com/apioption/6.png"*/}
                                    {/*                    alt=""/>*/}
                                    {/*            </div>*/}
                                    {/*            <div className="image">*/}
                                    {/*                <img*/}
                                    {/*                    src="https://vendor-provider.fra1.cdn.digitaloceanspaces.com/apioption/7.png"*/}
                                    {/*                    alt=""/>*/}
                                    {/*            </div>*/}
                                    {/*            <div className="image">*/}
                                    {/*                <img*/}
                                    {/*                    src="https://vendor-provider.fra1.cdn.digitaloceanspaces.com/apioption/8.png"*/}
                                    {/*                    alt=""/>*/}
                                    {/*            </div>*/}
                                    {/*            <div className="image">*/}
                                    {/*                <img*/}
                                    {/*                    src="https://vendor-provider.fra1.cdn.digitaloceanspaces.com/apioption/9.png"*/}
                                    {/*                    alt=""/>*/}
                                    {/*            </div>*/}
                                    {/*        </div>*/}
                                    {/*        <div className="content-holder">*/}
                                    {/*            <ul*/}
                                    {/*                className="nav nav-pills mb-3"*/}
                                    {/*                id="pills-tab"*/}
                                    {/*                role="tablist"*/}
                                    {/*            >*/}
                                    {/*                <li className="nav-item" role="presentation">*/}
                                    {/*                    <button*/}
                                    {/*                        className="nav-link active"*/}
                                    {/*                        id="pills-crypto-tab"*/}
                                    {/*                        data-toggle="pill"*/}
                                    {/*                        data-target="#pills-crypto"*/}
                                    {/*                        type="button"*/}
                                    {/*                        role="tab"*/}
                                    {/*                        aria-controls="pills-crypto"*/}
                                    {/*                        aria-selected="true"*/}
                                    {/*                    >*/}
                                    {/*                        Crypto Futures*/}
                                    {/*                    </button>*/}
                                    {/*                </li>*/}
                                    {/*                <li className="nav-item" role="presentation">*/}
                                    {/*                    <button*/}
                                    {/*                        className="nav-link"*/}
                                    {/*                        id="pills-features-tab"*/}
                                    {/*                        data-toggle="pill"*/}
                                    {/*                        data-target="#pills-features"*/}
                                    {/*                        type="button"*/}
                                    {/*                        role="tab"*/}
                                    {/*                        aria-controls="pills-features"*/}
                                    {/*                        aria-selected="false"*/}
                                    {/*                    >*/}
                                    {/*                        BINARY*/}
                                    {/*                    </button>*/}
                                    {/*                </li>*/}
                                    {/*                <li className="nav-item" role="presentation">*/}
                                    {/*                    <button*/}
                                    {/*                        className="nav-link"*/}
                                    {/*                        id="pills-fx-tab"*/}
                                    {/*                        data-toggle="pill"*/}
                                    {/*                        data-target="#pills-fx"*/}
                                    {/*                        type="button"*/}
                                    {/*                        role="tab"*/}
                                    {/*                        aria-controls="pills-fx"*/}
                                    {/*                        aria-selected="false"*/}
                                    {/*                    >*/}
                                    {/*                        Fx Futures*/}
                                    {/*                    </button>*/}
                                    {/*                </li>*/}
                                    {/*            </ul>*/}
                                    {/*            <div className="tab-content" id="pills-tabContent">*/}
                                    {/*                <div*/}
                                    {/*                    className="tab-pane fade show active"*/}
                                    {/*                    id="pills-crypto"*/}
                                    {/*                    role="tabpanel"*/}
                                    {/*                    aria-labelledby="pills-crypto-tab"*/}
                                    {/*                >*/}
                                    {/*                    <div className="tab-list tab-list-green">*/}
                                    {/*                        <a href="#" className="tab-block active" data-id={3}>*/}
                                    {/*                            <div className="count">1</div>*/}
                                    {/*                            <div className="text">*/}
                                    {/*                                Sembol bölümünden işlem yapmak istediğiniz ürünü*/}
                                    {/*                                seçiniz.*/}
                                    {/*                            </div>*/}
                                    {/*                        </a>*/}
                                    {/*                        <a href="#" className="tab-block" data-id={4}>*/}
                                    {/*                            <div className="count">2</div>*/}
                                    {/*                            <div className="text">*/}
                                    {/*                                İşlem yapacağınız yönü Al, Sat,{" "}*/}
                                    {/*                                <span className="green">Çarpan</span> oranını ve*/}
                                    {/*                                Bağlayacağınız{" "}*/}
                                    {/*                                <span*/}
                                    {/*                                    className="green">Teminat Miktarını</span>{" "}*/}
                                    {/*                                belirleyin.*/}
                                    {/*                            </div>*/}
                                    {/*                        </a>*/}
                                    {/*                        <a href="#" className="tab-block" data-id={5}>*/}
                                    {/*                            <div className="count">3</div>*/}
                                    {/*                            <div className="text">*/}
                                    {/*                                İşlem aç'a tıklayarak açık işlemler menüsünde*/}
                                    {/*                                işleminizi takip edip; Kazanca geçmeniz*/}
                                    {/*                                durumunda{" "}*/}
                                    {/*                                <span className="green">[Kapat]</span> tuşuna*/}
                                    {/*                                tıklayarak kazanç elde edebilirsiniz.*/}
                                    {/*                            </div>*/}
                                    {/*                        </a>*/}
                                    {/*                    </div>*/}
                                    {/*                </div>*/}
                                    {/*                <div*/}
                                    {/*                    className="tab-pane fade"*/}
                                    {/*                    id="pills-features"*/}
                                    {/*                    role="tabpanel"*/}
                                    {/*                    aria-labelledby="pills-features-tab"*/}
                                    {/*                >*/}
                                    {/*                    <div className="tab-list tab-list-blue">*/}
                                    {/*                        <a href="#" className="tab-block active" data-id={0}>*/}
                                    {/*                            <div className="count">1</div>*/}
                                    {/*                            <div className="text">*/}
                                    {/*                                Sol üst tarafta bulunan Sembol listesinden işlem*/}
                                    {/*                                yapacağınız sembolü seçiniz.*/}
                                    {/*                            </div>*/}
                                    {/*                        </a>*/}
                                    {/*                        <a href="#" className="tab-block" data-id={1}>*/}
                                    {/*                            <div className="count">2</div>*/}
                                    {/*                            <div className="text">*/}
                                    {/*                                İşleme girmek istediğiniz{" "}*/}
                                    {/*                                <span className="blue">Süre</span> ve{" "}*/}
                                    {/*                                <span className="blue">Miktar</span>'ı seçiniz.*/}
                                    {/*                            </div>*/}
                                    {/*                        </a>*/}
                                    {/*                        <a href="#" className="tab-block" data-id={2}>*/}
                                    {/*                            <div className="count">3</div>*/}
                                    {/*                            <div className="text">*/}
                                    {/*                                Seçtiğiniz sürede ürün fiyatının düşeceğini*/}
                                    {/*                                düşünüyorsanız <span className="red">Düşer</span>'e*/}
                                    {/*                                yükseleceğini düşünüyorsanız{" "}*/}
                                    {/*                                <span className="green">Yükselir</span>'e*/}
                                    {/*                                tıklayınız.Tahmininiz doğru sonuçlanırsa kazanç elde*/}
                                    {/*                                edersiniz.*/}
                                    {/*                            </div>*/}
                                    {/*                        </a>*/}
                                    {/*                    </div>*/}
                                    {/*                </div>*/}
                                    {/*                <div*/}
                                    {/*                    className="tab-pane fade"*/}
                                    {/*                    id="pills-fx"*/}
                                    {/*                    role="tabpanel"*/}
                                    {/*                    aria-labelledby="pills-fx-tab"*/}
                                    {/*                >*/}
                                    {/*                    <div className="tab-list tab-list-yellow">*/}
                                    {/*                        <a href="#" className="tab-block active" data-id={3}>*/}
                                    {/*                            <div className="count">1</div>*/}
                                    {/*                            <div className="text">*/}
                                    {/*                                Sembol bölümünden işlem yapmak istediğiniz ürünü*/}
                                    {/*                                seçiniz.*/}
                                    {/*                            </div>*/}
                                    {/*                        </a>*/}
                                    {/*                        <a href="#" className="tab-block" data-id={4}>*/}
                                    {/*                            <div className="count">2</div>*/}
                                    {/*                            <div className="text">*/}
                                    {/*                                İşlem yapacağınız yönü Al, Sat,{" "}*/}
                                    {/*                                <span className="yellow">Çarpan</span> oranını ve*/}
                                    {/*                                Bağlayacağınız{" "}*/}
                                    {/*                                <span*/}
                                    {/*                                    className="yellow">Teminat Miktarını</span>{" "}*/}
                                    {/*                                belirleyin.*/}
                                    {/*                            </div>*/}
                                    {/*                        </a>*/}
                                    {/*                        <a href="#" className="tab-block" data-id={5}>*/}
                                    {/*                            <div className="count">3</div>*/}
                                    {/*                            <div className="text">*/}
                                    {/*                                İşlem aç'a tıklayarak açık işlemler menüsünde*/}
                                    {/*                                işleminizi takip edip; Kazanca geçmeniz*/}
                                    {/*                                durumunda{" "}*/}
                                    {/*                                <span className="yellow">[Kapat]</span> tuşuna*/}
                                    {/*                                tıklayarak kazanç elde edebilirsiniz.*/}
                                    {/*                            </div>*/}
                                    {/*                        </a>*/}
                                    {/*                    </div>*/}
                                    {/*                </div>*/}
                                    {/*            </div>*/}
                                    {/*        </div>*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}
                                </div>
                            </div>
                        </div>
                    </main>
                    {/* #Home */}
                </div>
                {/* #General Container */}
            </div>
        </>

    );
}

export default App;
